import { useState } from "react";
import tabletrans from "../../translate/tables";
import OrderTableRow from "./OrderTableRow";
import { sortArray } from "../../env";

function OrderTable(props) {
  const orderList = props.content;
  const lang = props.lang.lang;
  var sort = "";
  const [detail, showDetail] = useState(-1);
  return (
    <table>
      <thead>
        <tr>
          <th></th>
          <th>
            <p style={{ whiteSpace: "nowrap" }}>کد محصول</p>
          </th>
          <th>
            <p>نام محصول</p>
          </th>
          <th>
            <p>تعداد</p>
          </th>
          <th>
            <p>قیمت</p>
          </th>
        </tr>
      </thead>
      <tbody>
        {orderList
          ? sortArray(orderList).map((object, i) => (
              <OrderTableRow order={object} index={i} key={i} lang={lang} />
            ))
          : ""}
      </tbody>
    </table>
  );
}
export default OrderTable;
